import { User } from '../store';

export const getDisplayName = (user: User) => {
  if (user.displayName) {
    return user.displayName;
  }

  return `${user.firstName} ${user.lastName}`.trim() || user.username;
};
